<template>
<transition name="slide">
  <div class="rank">
	 <scroll class="toplist" >
      <ul>
        <li class="item" >
          <div class="icon">
            <a href="https://y.qq.com/n/yqq/toplist/4.html#stat=y_new.toplist.menu.4"><img width="100" height="100" src="http://y.gtimg.cn/music/common/upload/t_order_channel_hitlist_conf/64072.png"></a>
          </div>
          <ul class="songlist">
            <li class="song">
              <a href="https://y.qq.com/n/yqq/toplist/4.html#stat=y_new.toplist.menu.4">安利XS·巅峰榜·流行指数</a>
              
            </li>
          </ul>
        </li>

        <li class="item" >
          <div class="icon">
            <a href="https://y.qq.com/n/yqq/toplist/26.html#stat=y_new.toplist.menu.26"><img width="100" height="100" src="http://y.gtimg.cn/music/common/upload/iphone_order_channel/20150820172909.jpg"></a>
          </div>
          <ul class="songlist">
            <li class="song">
              <a href="https://y.qq.com/n/yqq/toplist/26.html#stat=y_new.toplist.menu.26">巅峰榜·热歌</a>
              
            </li>
          </ul>
        </li>
         <li class="item" >
          <div class="icon">
            <img width="100" height="100" src="http://y.gtimg.cn/music/common/upload/iphone_order_channel/20150820172435.jpg">
          </div>
          <ul class="songlist">
            <li class="song">
              <a>巅峰榜·新歌</a>
              
              
            </li>
          </ul>
        </li>
         <li class="item" >
          <div class="icon">
            <a href="https://y.qq.com/n/yqq/toplist/33.html#stat=y_new.toplist.menu.33"><img width="100" height="100" src="http://y.gtimg.cn/music/common/upload/t_order_channel_hitlist_conf/234556.jpg"></a>
          </div>
          <ul class="songlist">
            <li class="song">
             <a href="https://y.qq.com/n/yqq/toplist/33.html#stat=y_new.toplist.menu.33">全军出击·巅峰榜·歌手2018</a>

            </li>
          </ul>
        </li>
        <li class="item" >
          <div class="icon">
            <a href="https://y.qq.com/n/yqq/toplist/30.html#stat=y_new.toplist.menu.30"><img width="100" height="100" src="http://y.gtimg.cn/music/common/upload/t_order_channel_hitlist_conf/200132.jpg"></a>
          </div>
          <ul class="songlist">
            <li class="song">
             <a href="https://y.qq.com/n/yqq/toplist/30.html#stat=y_new.toplist.menu.30">巅峰榜·梦想的声音</a>
            </li>
          </ul>
        </li>
        <li class="item" >
          <div class="icon">
            <a href="https://y.qq.com/n/yqq/toplist/28.html#stat=y_new.toplist.menu.28"><img width="100" height="100" src="http://y.gtimg.cn/music/common/upload/t_order_channel_hitlist_conf/47905.png"></a>
          </div>
          <ul class="songlist">
            <li class="song">
             <a href="https://y.qq.com/n/yqq/toplist/28.html#stat=y_new.toplist.menu.28">巅峰榜·网络歌曲</a>
            </li>
          </ul>
        </li>
         <li class="item" >
          <div class="icon">
            <a href="https://y.qq.com/n/yqq/toplist/28.html#stat=y_new.toplist.menu.28"><img width="100" height="100" src="http://y.gtimg.cn/music/common/upload/iphone_order_channel/20140519103525.jpg"></a>
          </div>
          <ul class="songlist">
            <li class="song">
             <a href="https://y.qq.com/n/yqq/toplist/28.html#stat=y_new.toplist.menu.28">巅峰榜·内地</a>
            </li>
          </ul>
        </li>
        <li class="item" >
          <div class="icon">
            <a href="https://y.qq.com/n/yqq/toplist/6.html#stat=y_new.toplist.menu.6"><img width="100" height="100" src="http://y.gtimg.cn/music/common/upload/iphone_order_channel/20140519103855.jpg"></a>
          </div>
          <ul class="songlist">
            <li class="song">
             <a href="https://y.qq.com/n/yqq/toplist/6.html#stat=y_new.toplist.menu.6">巅峰榜·港台</a>
            </li>
          </ul>
        </li>
        <li class="item" >
          <div class="icon">
            <a href="https://y.qq.com/n/yqq/toplist/3.html#stat=y_new.toplist.menu.3"><img width="100" height="100" src="http://y.gtimg.cn/music/common/upload/iphone_order_channel/20140519104205.jpg"></a>
          </div>
          <ul class="songlist">
            <li class="song">
             <a href="https://y.qq.com/n/yqq/toplist/3.html#stat=y_new.toplist.menu.3">巅峰榜·欧美</a>
            </li>
          </ul>
        </li>
         <li class="item" >
          <div class="icon">
            <a href="https://y.qq.com/n/yqq/toplist/108.html#stat=y_new.toplist.menu.108"><img width="100" height="100" src="http://y.gtimg.cn/music/common/upload/iphone_order_channel/20140421145230.jpg"></a>
          </div>
          <ul class="songlist">
            <li class="song">
             <a href="https://y.qq.com/n/yqq/toplist/108.html#stat=y_new.toplist.menu.108">美国公告牌榜</a>
            </li>
          </ul>
        </li>
         <li class="item" >
          <div class="icon">
            <a href="https://y.qq.com/n/yqq/toplist/36.html#stat=y_new.toplist.menu.36"><img width="100" height="100" src="http://y.gtimg.cn/music/common/upload/t_order_channel_hitlist_conf/34151.png"></a>
          </div>
          <ul class="songlist">
            <li class="song">
             <a href="https://y.qq.com/n/yqq/toplist/36.html#stat=y_new.toplist.menu.36">高品质音乐</a>
            </li>
          </ul>
        </li>
      </ul> 
    </scroll>
 <router-view></router-view>
  </div>
</transition>
</template>

<script type="text/ecmascript-6">
  import Scroll from 'base/scroll/scroll'
  import {getTopList} from 'api/rank'
  import {ERR_OK} from 'api/config'
  export default{
    created(){
      this._getTopList()
    },
    methods:{
      _getTopList(){
        getTopList().then((res)=>{
          
        })
      }
    },
    components: {
      Scroll
      
    }
  }
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
 @import "~common/stylus/variable"
  @import "~common/stylus/mixin"

  
  .rank
    position: fixed
    width: 100%
    top: 88px
    bottom: 0
    .toplist
      height: 100%
      overflow: hidden
      .item
        display: flex
        margin: 0 20px
        padding-top: 20px
        height: 100px
        &:last-child
          padding-bottom: 20px
        .icon
          flex: 0 0 100px
          width: 100px
          height: 100px
        .songlist
          flex: 1
          display: flex
          flex-direction: column
          justify-content: center
          padding: 0 20px
          height: 100px
          overflow: hidden
          background: $color-highlight-background
          color: $color-text-d
          font-size: 18px
          .song
            no-wrap()
            line-height: 26px
      .loading-container
        position: absolute
        width: 100%
        top: 50%
        transform: translateY(-50%)
.slide-enter-active{
    transition:all 0.3s
  }
  .slide-leave-active{
  	transition:all
  }
  .slide-enter,.slide-leave-to{
    transform:translate3d(100%,0,0);
  }

</style>



// WEBPACK FOOTER //
// src/components/rank/rank.vue